<app-page-breadcrumb pageTitle="Detalle del pipeline"></app-page-breadcrumb>

<div class="space-y-4">
  <button type="button" (click)="volver()"
    class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
    </svg>
    Volver a pipelines
  </button>

  @if (loading) {
    <div class="flex justify-center py-12"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div></div>
  }
  @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  @if (pipeline) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5">
    <div class="flex items-start justify-between gap-3 flex-wrap">
      <div class="min-w-0">
        <h1 class="text-xl font-bold text-gray-900 dark:text-white">{{ pipeline.name }}</h1>
        @if (pipeline.description) {
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">{{ pipeline.description }}</p>
        }
        <div class="flex flex-wrap gap-2 mt-2">
          @if (pipeline.isDefault) {
            <span class="text-xs px-2 py-0.5 rounded-full font-medium bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">Predeterminado</span>
          }
          <span class="text-xs px-2 py-0.5 rounded-full font-medium"
            [ngClass]="pipeline.isActive
              ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300'
              : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'">
            {{ pipeline.isActive ? 'Activo' : 'Inactivo' }}
          </span>
          <span class="text-xs text-gray-400">Orden: {{ pipeline.sortOrder }}</span>
        </div>
      </div>
      <button type="button" (click)="editarPipeline()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        Editar pipeline
      </button>
    </div>
  </div>

  <!-- Stages -->
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl">
    <div class="flex items-center justify-between gap-3 p-4 border-b border-gray-200 dark:border-gray-700">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Etapas ({{ stages.length }})</h2>
      <button type="button" (click)="nuevaEtapa()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nueva etapa
      </button>
    </div>
    <div class="overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Orden</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Color</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado mapeado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Cierre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (stages.length === 0) {
            <tr><td colspan="6" class="px-5 py-8 text-center text-sm text-gray-500 dark:text-gray-400">Sin etapas. Crea una para empezar.</td></tr>
          }
          @for (stage of stages; track stage.id) {
          <tr>
            <td class="px-5 py-3 text-sm text-gray-700 dark:text-gray-300">{{ stage.sortOrder }}</td>
            <td class="px-5 py-3 text-sm font-medium text-gray-900 dark:text-white">
              {{ stage.name }}
              @if (stage.description) {
                <p class="text-xs text-gray-500 dark:text-gray-400 font-normal">{{ stage.description }}</p>
              }
            </td>
            <td class="px-5 py-3 text-sm">
              @if (stage.color) {
                <div class="flex items-center gap-2">
                  <div class="w-4 h-4 rounded" [style.background-color]="stage.color"></div>
                  <span class="text-xs font-mono text-gray-500">{{ stage.color }}</span>
                </div>
              } @else { <span class="text-gray-400">—</span> }
            </td>
            <td class="px-5 py-3 text-sm text-gray-700 dark:text-gray-300">{{ getStatusLabel(stage.idTicketStatus) }}</td>
            <td class="px-5 py-3">
              @if (stage.isClosedStage) {
                <span class="text-xs px-2 py-0.5 rounded-full font-medium bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300">Cierre</span>
              } @else { <span class="text-gray-400">—</span> }
            </td>
            <td class="px-5 py-3 text-center">
              <div class="flex items-center justify-center gap-2">
                <button (click)="editarEtapa(stage)" title="Editar"
                  class="rounded-lg p-2 text-gray-500 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                </button>
                <button (click)="eliminarEtapa(stage)" title="Eliminar"
                  class="rounded-lg p-2 text-gray-500 hover:bg-error-50 hover:text-error-600 transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
</div>
